import { Box, Typography, IconButton, TextField, Tooltip, Button, LinearProgress } from '@mui/material'
import { useEquipment } from '../../../shared/context/equipmentContext'
import { useEffect } from 'react'
import { Refresh as RefreshIcon } from '@mui/icons-material'
import { Add as AddIcon } from '@mui/icons-material'    
import WidgetsIcon from '@mui/icons-material/Widgets';
import { useUtiles } from '../../../shared/context/utilesContext'
import CreateTypeEquipmentComponent from './CreateTypeEquipmentComponent'
export const SelectTypeEquipmentComponent = ({ setSelectTypeEquipment }) => {

    const { typeEquipments, getTypeEquipments, loadingTypeEquipments } = useEquipment()
    const { toogleOpenSilder, saveCurrentComponent, openSilderWith  } = useUtiles()

    const handleSearch = (e) => {
        getTypeEquipments({ name: e.target.value })
    }


    const handleSelectTypeEquipment = (typeEquipment) => {
        setSelectTypeEquipment(typeEquipment)
        toogleOpenSilder(null, 600, 'Crear Tipo de Equipo')
    }

    const handleCreateTypeEquipment = () => {
        saveCurrentComponent()
        openSilderWith(<CreateTypeEquipmentComponent />, 600, 'Crear Tipo de Equipo')
    } 


    useEffect(() => {
        getTypeEquipments()
    }, [])

    return (
        <Box sx={{ padding: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField fullWidth placeholder="Escribe para buscar" size="small" onChange={handleSearch} />
            <Tooltip title="Refrescar">
                <IconButton size="small" onClick={() => getTypeEquipments()}>
                    <RefreshIcon  />
                </IconButton>
            </Tooltip>
        </Box>
        <Button 
            size="small" 
            variant="contained" 
            color="primary" 
            sx={{ mt: 1 }} 
            startIcon={<AddIcon />}
            onClick={handleCreateTypeEquipment}
        >
            Crear tipo de equipo
        </Button>

 
        { loadingTypeEquipments && <LinearProgress sx={{ mt: 2 }} />}

        <Box sx={{ mt: 2, maxHeight: '300px', overflow: 'auto', px: 1 }}>
            {typeEquipments.length > 0 ? (
                typeEquipments.map((type) => (
                    <Box 
                        key={type.id}
                        sx={(theme) => ({
                            p: 1.5,
                            mb: 1,
                            borderRadius: "8px",
                            backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                            transition: 'all 0.2s',
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
                            },
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            transition: 'all 0.2s ease',
                            
                        })}
                        onClick={() => handleSelectTypeEquipment(type)}
                    >
                        <Box sx={{ 
                                mr: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                backgroundColor: (theme) => theme.palette.primary.main,
                                color: '#fff'
                            }}>
                            <IconButton size="small" sx={(theme) => ({ 
                                color: "#fff",
                                p: 0.5
                            })}>
                                <WidgetsIcon fontSize="small" />
                            </IconButton>

                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" sx={(theme) => ({ 
                                color: theme.palette.text.primary,
                                fontWeight: 500
                            })}>
                                {type.name}
                            </Typography>
                        </Box>
                   
                    </Box>
                ))
            ) : (
                <Box sx={(theme) => ({ 
                    textAlign: 'center', 
                    py: 4,
                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
                    borderRadius: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1
                })}>
                    <RefreshIcon sx={(theme) => ({ color: theme.palette.text.secondary, opacity: 0.5 })} />
                    <Typography variant="body2" color="text.secondary">
                        No hay tipos de equipo disponibles
                    </Typography>
                </Box>
            )}
        </Box>

        </Box>
    )
}